module.exports = __webpack_public_path__ + "static/media/CPG_super_618x414.c2b2c34a.png";